//
// Copyright (c) 2019-Present Syncari - All rights reserved.
//
import React from 'react';
import { Slider } from 'antd';
import { SliderValue } from 'antd/lib/slider';
import cx from 'classnames';

import { FuzzySliderPanelProps } from '../types';

/**
 * FuzzySliderPanel component displays a slider for adjusting fuzzy matching parameters
 * Supports both percentage (0-100) and typo count (1-4) modes
 */
const FuzzySliderPanel: React.FC<FuzzySliderPanelProps> = ({
  option,
  percentage,
  typoCount,
  isExpanded,
  onSliderChange,
}) => {
  const isTypoConfig = option.hasMinMaxTypoConfig ?? false;

  // Determine which value to display based on config type
  const displayValue = isTypoConfig ? typoCount : percentage;

  return (
    <div
      className={cx('fuzzy-slider-panel', { 'fuzzy-slider-panel--expanded': isExpanded })}
      onClick={(e) => e.stopPropagation()}>
      <div className="fuzzy-slider-content">
        <div className="fuzzy-slider-row">
          {isTypoConfig ? (
            <>
              <Slider
                min={1}
                max={5}
                step={1}
                value={displayValue as SliderValue}
                onChange={(val) => onSliderChange(val as number)}
                tipFormatter={(val) => {
                  const typoText = val === 1 ? 'typo' : 'typos';
                  return `Max ${val} ${typoText}`;
                }}
              />
              <span className="fuzzy-slider-typo" data-testid="fuzzy-slider-value">
                Max {displayValue} {displayValue === 1 ? 'typo' : 'typos'}
              </span>
            </>
          ) : (
            <>
              <Slider
                min={0}
                max={100}
                step={10}
                value={displayValue as SliderValue}
                onChange={(val) => onSliderChange(val as number)}
                tipFormatter={(val) => `${val}%`}
              />
              <span className="fuzzy-slider-percentage" data-testid="fuzzy-slider-value">
                {displayValue}%
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FuzzySliderPanel;
